import React, {ReactElement} from 'react';
import NumberFormat, {NumberFormatProps} from 'react-number-format';

export type NxDefaultNumberFormat = Pick<NumberFormatProps, 'onValueChange' | 'displayType' | 'decimalScale' | 'getInputRef'>;

export const NxDefaultNumberFormat = (props: NxDefaultNumberFormat): ReactElement => (
  <NumberFormat
    fixedDecimalScale
    isNumericString
    thousandSeparator
    {...props}
  />
);
